import { useEffect, useRef } from 'react';
import { useCasesStore } from '../store/casesStore';

const POLLING_INTERVAL = 5000; // Poll every 5 seconds

/**
 * Hook to poll for case status updates.
 * This ensures the UI reflects real-time status changes as individual
 * translations complete, without waiting for the entire batch to finish.
 */
export function useCasesPolling(enabled: boolean = true) {
  const fetchCases = useCasesStore((state) => state.fetchCases);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (!enabled) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      return;
    }

    // Start polling
    intervalRef.current = setInterval(() => {
      fetchCases();
    }, POLLING_INTERVAL);

    // Cleanup on unmount or when disabled
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [enabled, fetchCases]);
}
